import Header from '../../components/Header'
import HeaderImage from '../../images/header_bg_2.jpg'
import {MdEmail} from 'react-icons/md'
import {BsMessenger} from 'react-icons/bs'
import {IoLogoWhatsapp} from 'react-icons/io'
import './contact.css'

const Contact = () => {
  return (
    <>
    <Header title="Get In Touch" image={HeaderImage}>
      MY SELF MR.ADITYA KUMAR, I AM FULL STACK WEB DEVELOPER AND APP DEVELOPER. I HAVE DONE GRADUATION FROM SRI GADADHAR ACHARYA JANTA COLLEGE.
    </Header>
    <section >
      <div className="container contact__container">
        <div className="contact__wrapper">
          <a href="mailto:aditya822003@gmail.com" target="_blank" rel="noreferrer noopener"><MdEmail/></a>
          <a href="http://WWW.google.com" target="_blank" rel="noreferrer noopener"><BsMessenger/></a>
          <a href="https://wa.me/+919060722799" target="_blank" rel="noreferrer noopener"><IoLogoWhatsapp/></a>
        </div>
      </div>
    </section>
    </>
  )
}

export default Contact